/* tslint:disable */
/* eslint-disable */
export enum MembershipView {
  CHANGE_PLANS,
  FREEMIUM,
  PLAN_DETAILS
}

export enum PlanView {
  MONTHLY,
  YEARLY
}
